module.exports = __webpack_public_path__ + "static/AfterPayLogoTransparent-f266d536d4d577c8dc04043b632849b8.svg";